module.exports = __webpack_public_path__ + "static/media/Deer-Creek-Plymouth-By-Laws.8284a709.pdf";